import { Box, Link } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';
import React from 'react';
import ReactMarkdown, { uriTransformer } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import rehypeSanitize from 'rehype-sanitize';
import { getImage, ImageSize } from '@shared/utils/imageFormat';

export interface IProps {
  text: string;
  conferenceId: string;
}

const useStyles = (theme: Theme) => ({
  image: {
    maxWidth: '100% !important',
  },
  content: {
    '& blockquote': {
      borderWidth: "0 !important",
      borderLeftWidth: "8px !important",
      borderStyle: 'solid !important',
      backgroundColor: `${theme.palette.background.paper} !important`,
      borderColor: `${theme.palette.divider} !important`,
      margin: "0px !important",
      padding: '1px 10px !important',
    },
    '& pre': {
      backgroundColor: `${theme.palette.background.paper} !important`,
      padding: "4px !important",
    },
    '& table': {
      margin: '8px 0px !important',
      borderStyle: 'solid !important',
      borderWidth: "1px !important",
      borderColor: `${theme.palette.divider} !important`,
      borderCollapse: 'collapse !important',
      //   tableLayout: 'fixed',
    },
    '& th': {
      backgroundColor: `${theme.palette.background.paper} !important`,
      padding: "3px !important",
    },
    '& td': {
      borderStyle: 'solid',
      borderWidth: "1px !important",
      borderColor: `${theme.palette.divider} !important`, 
      padding: "3px !important",
    },
    '& .task-list-item': {
      listStyleType: 'none !important',
      marginLeft: "-20px !important",
    },
  },
});

// const img_default_width = 600;
// const coeoImageStart = `https://${process.env.STATIC_IMAGES}`;
// Only allow coeo images
const userInputImageUri = (conferenceId: string) => (
  src: string,
  alt: string,
  title: string
) => {
  if (src.indexOf('/') >= 0) {
    return '/images/no_external_images.png';
  } else {
    return uriTransformer(getImage(src, ImageSize.Default, conferenceId));
  }
  //   const isCoeoImage = src.toLowerCase().indexOf(coeoImageStart) === 0;
  //   if (isCoeoImage) {
  //     return `${uriTransformer(
  //       src.split('?').shift()
  //     )}?width=${img_default_width}`; // Add default WIDTH to Coeo image
  //   } else {
  //     return '/images/no_external_images.png';
  //   }
};

export const ManagerMarkdownRender = React.memo(
  ({ text, conferenceId }: IProps) => {
    const theme = useTheme();
    const classes = useStyles(theme);

    const configs = {
      trusted: {
        linkTarget: '_blank',
      },
      userInput: {
        linkTarget: '_blank',
        components: {
          a: (props: any) => {
            return <Link {...props} />;
          },
          img: (props: any) => <Box component="img" sx={classes.image} {...props} />,
        },
      },
    };

    return (
      <ReactMarkdown
        children={text}
        sx={classes.content}
        linkTarget="_blank" // (href, children, title) => string
        style={{ minHeight: '500px' }}
        components={configs['userInput'].components}
        remarkPlugins={[remarkGfm, remarkBreaks]}
        rehypePlugins={[rehypeSanitize]}
        transformImageUri={userInputImageUri(conferenceId)}
        imageAccept={'.jpg,.jpeg,.png'}
      />
    );
  },
  (prevProps, nextProps) => prevProps.text === nextProps.text
);

ManagerMarkdownRender.displayName = 'ManagerMarkdownRender';
